import React, { useState,useRef } from "react";
import classes from "./DepartmentsMobile.module.css";

// import { useSelector,useDispatch } from "react-redux";
// import { DepartmentsActions } from "../../../store/Slices/DepartmentsSlice";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/all";
// import { ScrollActions } from "../../../store/Slices/ScrollSlice";



import close from "../../../images/svgs/close.svg";
import Menu from "./Menu/Menu";
import Space from "../../UI/Space/Space"

const DepartmentsMobile = (props) => {
  // const dispatch = useDispatch();
  let container = useRef(null)

  // gsap.registerPlugin(ScrollTrigger)
  // const department = useSelector((state)=>state.departments.department);


  // useEffect(() => {
  //   console.log("DEP",container.current.getBoundingClientRect())

  //   ScrollTrigger.create({
  //     trigger: container.current,
  //     start: "top bottom",
  //     end: "bottom bottom",
  //     scrub: true,
  //     onUpdate: (self) => {
  //       // console.log("progress", self.progress);
  //       dispatch(ScrollActions.UpdateDepartments(self.progress));
  //     },
  //   });
    
  // }, []);



  // const [rerender, setRerender] = useState(0);
  
  return (
    <div className={classes.container} ref={container}>
      <Menu small={props.small}/>
      {props.small? <Space height={20}/>:<Space height={50}/>}
    </div>
  );
};
export default DepartmentsMobile;
